class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    openpopupInsideDrawer();
    openpopupInsideDrawerbarrage();
   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContentsUpdates() {
    openpopupInsideDrawer();
    openpopupInsideDrawerbarrage();
    checkAndRemoveItems();
    checkCartTotal();
    checkCartProducts();
    loadTogglestate();
    wishlistRender();
    trigetDiscountFiled();
    fetchCartItemsCount();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  renderContents(parsedState) {
    /*this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));*/
    // add bundles to the cart drawer
    if (parsedState?.id) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      this.renderContentsUpdates();
    } else {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          $('.drawer').removeClass('is-empty');
          document.querySelector('#CartDrawer').innerHTML = html.querySelector('#CartDrawer').innerHTML;
        }).finally(() => {
          this.renderContentsUpdates();
        });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      // {
      //   id: 'cart-icon-bubble'
      // }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section'
      // }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// NEW FUNCTION for element counting and adaptation to recharge
function fetchCartItemsCount(bundleHandler = false) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => response.json())
    .then((cart) => {
      const uniqueItems = {};

      cart.items.forEach((item) => {
        if (item.properties && item.properties._rc_bundle) {
          const bundleId = item.properties._rc_bundle;

          if (!uniqueItems[bundleId]) {
            uniqueItems[bundleId] = item.quantity;
          }
        } else {

          uniqueItems[item.key] = item.quantity;
        }
      });
      
      const cDW = document.querySelector('cart-drawer');
      const totalUniqueProducts = Object.keys(uniqueItems).length;
      const counterContainer = document.querySelector('.cart-count-bubble [aria-hidden="true"]');

      if (counterContainer) {
        counterContainer.textContent = `${totalUniqueProducts > 0 ? totalUniqueProducts : ""}`;
      }
      if (bundleHandler && cDW) {
        setTimeout(() => {
          cDW.classList.toggle('is-empty', totalUniqueProducts === 0);
        }, 500);
      }
    })
    .catch((error) => console.error('Error fetching cart:', error));
}
fetchCartItemsCount();
// NEW FUNCTION to adapt the removal of the entire bundle recharge
async function checkAndRemoveRechargeItems(bundleId) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(cart => {
      const updates = cart.items.reduce((acc, item, index) => {
        if (item.properties && item.properties._rc_bundle === bundleId) {
          acc[item.key] = 0;
        }
        return acc;
      }, {});

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
    })
    .then(response => response.json())
    .then(updatedCart => {
      console.log('Updated cart:', updatedCart);
    })
    .catch(error => console.error('Error updating cart:', error));
}

//Pop Up Script
function openpopupInsideDrawer() {
  const clickcartPU = document.getElementById("showPUcart");
  const popupcart = document.getElementById("addon-popup-cart");
  const closecartPU = document.getElementById("hidePU");
  const closecartPUx = document.getElementById("hidePUx");

  if (clickcartPU && popupcart && closecartPU && closecartPUx) {
    clickcartPU.addEventListener('click', () => {
      popupcart.style.display = 'block';
    });
    
    popupcart.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
    
    closecartPU.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
    
    closecartPUx.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
  } else {
    console.warn("One or more elements not found on the page.");
  }
}


//Pop Up Script - Kit Barrage
function openpopupInsideDrawerbarrage() {
  const clickcartBarrage = document.getElementById("disco-checkout-intv");
  const barragecart = document.getElementById("barrage-popup-cart");
  //const closecartPUm = document.getElementById("hidePUm");
  //const closecartPUy = document.getElementById("hidePUy");

  if (clickcartBarrage && barragecart ) {
    clickcartBarrage.addEventListener('click', () => {
      barragecart.style.display = 'block';
    });
    
    /**barragecart.addEventListener('click', () => {
      barragecart.style.display = 'none';
    });**/
    
    /**closecartPUm.addEventListener('click', () => {
      barragecart.style.display = 'none';
    });**/
    
    /**closecartPUy.addEventListener('click', () => {
      barragecart.style.display = 'none';
    });**/
  } else {
    console.warn("One or more elements not found on the page.");
  }
}


function wishlistRender(){
  const wishlist_full = document.getElementById("wishlist-items");
  if (wishlist_full) {
    if (wishlist_full.innerHTML.trim() !== '') {
        // Wishlist is loaded, element is not empty
        //console.log('Element is not empty');
      } else {
        // Wishlist is not loaded, element is empty
        //console.log('Element is empty');
        //loading cart wishlist js
        setTimeout(() => {},1000)
        const script_1 = document.createElement('script');
        script_1.src = "//eightsaintsskincare.com/cdn/shop/t/40/assets/cart-wishlist-widget.js?&enable_js_minification=1";
        script_1.crossOrigin = "anonymous";
        script_1.defer = true;
        document.body.appendChild(script_1);
      }
    }
  }
wishlistRender()


//Remove items from cart if Has gift and kit products
function checkAndRemoveItems() {
  loadTogglestate();
  console.log('checking products HAS!!!');
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let hasGiftKitIndex = -1;
    
        cart.items.some((item, index) => {
            if (idsGiftKist.includes(item.product_id)) {
                hasGiftKitIndex = idsGiftKist.indexOf(item.product_id);
                return true;
            }
            return false;
        }); 

        if (hasGiftKitIndex !== -1) {
         
            let removeId = removeProductIfHasGiftKits[hasGiftKitIndex];
        
            let elementToRemove = document.querySelector(`cart-drawer-items .cart-item[data-productid="${removeId}"]`);
            if (elementToRemove) {
              elementToRemove.querySelector('cart-remove-button').click();
                console.log(`Removed item with ID: ${removeId}`);
            }
        }
    })
    .catch(error => console.error('Error fetching cart:', error));
}


//get total price and ids cart products
function checkCartTotal() {
  return fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
   
    const totalPrice = cart.total_price / 100;

    const productLists = cart.items.map(item => item.id);

    return {
      totalPrice,
      productLists
    };
  })
  .catch(error => {
    console.error('Помилка при отриманні кошика:', error);
    return null; 
  });
}

//Loading VIP toggle State
function loadTogglestate () {
  const vipCheckbox = document.getElementById('perk_cart_toggle');
  const checkboxKey = 'myCheckboxState';
  if (vipCheckbox) {
    // On page load, retrieve the checkbox state from session storage
    window.addEventListener('load', () => {
      const storedState = sessionStorage.getItem(checkboxKey);
      if (storedState) {
        vipCheckbox.checked = JSON.parse(storedState);
        if (vipCheckbox.checked) {
          console.log("Checkbox true");
          const checkoutButton = document.getElementById('CartDrawer-Checkout');
          const vipcheckoutButton = document.getElementById('Cart-Drawer-VIP-Checkout');    
          checkoutButton.classList.add('checkout_hide');
          vipcheckoutButton.classList.remove('checkout_hide');
        }
      }
    });
  };
}
loadTogglestate()


function loadCustomertoggleprice() {
  const viptotal = document.getElementById('vip-subtotal');
  const regtotal = document.getElementById('reg-subtotal');
  const viptog = document.getElementById('perk_cart_toggle'); 
  if (viptog.checked) {      
    regtotal.classList.add('checkout_hide');
    viptotal.classList.remove('checkout_hide');
    console.log('loading correct price 2');
  } else {
    regtotal.classList.remove('checkout_hide');
    viptotal.classList.add('checkout_hide');
    console.log('loading correct price 3');
 }
}

function loadVIPtoggle() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let hasProduct1 = false;
      let hasProduct2 = false;
      let hasMlab = false;
      let hasVip = false;    
      
      cart.items.forEach(item => {
        if (item.product_id === productIds[0]) {
          hasProduct1 = true;
        }
        if (item.product_id === productIds[1]) {
          hasProduct2 = true;
        }
        if (item.product_id === mlabIds[0] || item.product_id === mlabIds[1] || item.product_id === mlabIds[2] || item.product_id === mlabIds[3] ) {
          hasMlab = true;
        }
        if (item.product_id === vipIds[0] || item.product_id === vipIds[1] || item.product_id === vipIds[2] ) {
          hasVip = true;
        }
      });

      const viptoggle = document.getElementById('perk_cart_toggle');
      const checkoutButton = document.getElementById('CartDrawer-Checkout');
      const vipcheckoutButton = document.getElementById('Cart-Drawer-VIP-Checkout');  
      const checkboxKey = 'myCheckboxState';

      if (hasProduct1 || hasProduct2 || hasMlab) {
        if (hasVip) {
          sessionStorage.removeItem('myCheckboxState');
        };
        viptoggle.addEventListener('change', () => {

          sessionStorage.setItem(checkboxKey, JSON.stringify(viptoggle.checked));         
          if (viptoggle.checked) {      
              console.log("Opting In - ADD VIP To Cart");
              checkoutButton.classList.add('checkout_hide')
              vipcheckoutButton.classList.remove('checkout_hide')           
            } else {
              console.log("Opting Out - No VIP Offer");
              checkoutButton.classList.remove('checkout_hide')
              vipcheckoutButton.classList.add('checkout_hide')
           };
          
        });  

      } else if (hasVip) {
        console.log("VIP in cart");
        sessionStorage.removeItem('myCheckboxState');    
        
      } else {
        //const vipsubtotal = document.getElementById('vip-subtotal');
        //const regsubtotal = document.getElementById('reg-subtotal');   
        viptoggle.addEventListener('change', () => {

          sessionStorage.setItem(checkboxKey, JSON.stringify(viptoggle.checked));       
          if (viptoggle.checked) {      
              console.log("Opting In - ADD VIP To Cart");
              checkoutButton.classList.add('checkout_hide')
              vipcheckoutButton.classList.remove('checkout_hide')
              //regsubtotal.classList.add('checkout_hide')
              //vipsubtotal.classList.remove('checkout_hide')         
            } else {
              console.log("Opting Out - No VIP Offer");
              //regsubtotal.classList.remove('checkout_hide')
              //vipsubtotal.classList.add('checkout_hide')
              checkoutButton.classList.remove('checkout_hide')
              vipcheckoutButton.classList.add('checkout_hide')
           };
          
        });                                                                                             
      }
      
    })
    .catch(error => {
      
    });
} 

//function to creating Cookie if kits in cart for itelligems test
function kitCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

  //const productIds = [2043719581766, 6764342542439, 14620006646123, 14629727207787, 14624407224683 ,14649752355179, 14650219954539, 14662529941867];
  //Product 1 - Regular Kit, Product 2 - Deluxe Kit
  //Product3 is Viral Duo + Deluxe Kit
  //Product4 is VIP + FREE Deluxe Kit
  //Product5 is MLSR + Deluxe Kit
  //Product6 is AARoutine + Deluxe Kit
  //Product7 is VIP + Deluxe Kit
  //Product 8 is VIP one month Free
  //const mlabIds = [14654285021547, 14647623221611, 14639789605227, 14639736553835];
  //const vipIds = [6763916230759, 14662529941867, 14676068565355];

  function checkCartProducts() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        if (cart && Array.isArray(cart.items) && cart.items.length === 0) {
          console.log('Cart is empty');
          sessionStorage.removeItem('myCheckboxState');
        };
        
        let hasProduct1 = false;
        let hasProduct2 = false;
        let hasProduct3 = false;
        let hasProduct4 = false;
        let hasProduct5 = false;
        let hasProduct6 = false;
        let hasProduct7 = false;
        let hasProduct8 = false;
        let hasMlab = false;
        let hasPdp = false; 

        cart.items.forEach(item => {
          if (item.product_id === productIds[0]) {
            hasProduct1 = true;
          }
          if (item.product_id === productIds[1]) {
            hasProduct2 = true;
          }
          if (item.product_id === productIds[2]) {
            hasProduct3 = true;
            console.log('viral duo in cart');
          }
          if (item.product_id === productIds[3]) {
            hasProduct4 = true;
            console.log('VIP + FREE Deluxe Kit in cart');   
          }
          if (item.product_id === productIds[4]) {
            hasProduct5 = true;
            console.log('MLSR + Deluxe Kit in cart');
          }
          if (item.product_id === productIds[5]) {
            hasProduct6 = true;
            console.log('AA Routine + Deluxe Kit in cart');
          }
          if (item.product_id === productIds[6]) {
            hasProduct7 = true;
            console.log('VIP + Deluxe Kit in cart');
          }
         if (item.product_id === productIds[7]) {
            hasProduct8 = true;
            console.log('VIP One Month Free in cart');
          }
          if (item.product_id === mlabIds[0] || item.product_id === mlabIds[1] || item.product_id === mlabIds[2] || item.product_id === mlabIds[3] ) {
            hasMlab = true;
            console.log('Mlab in Cart');
          }
         if (item.product_id === pdpIds[0] || item.product_id === pdpIds[1] || item.product_id === pdpIds[2] ) {
            hasPdp = true;
            console.log('Pdp in Cart');
          }
        });

       
          if (hasProduct1) {

            //Setting Deluxe kit Cookie if in cart for itelligems test
            kitCookie("kitCart", "true", 14);
                 
            checkCartTotal().then(cartInfo => {
                  //add product gift
                  if(cartInfo.totalPrice >= giftProduct_1_price[0] && !cartInfo.productLists.includes(giftProductVariant_1_id[0])) {
                    console.log('simple gift after '+giftProduct_1_price[0]+' tor on')                   
                    document.querySelector(`#gift-product-${giftProductVariant_1_id[0]} button[name="add"]`).click();
                  }
                  //remove
                  if(cartInfo.totalPrice < giftProduct_1_price[0] && cartInfo.productLists.includes(giftProductVariant_1_id[0])) {
                    document.querySelector(`.cart-item[data-id="${giftProductVariant_1_id[0]}"] cart-remove-button`).click();
                  }
               
                  //add product gift
                  if(cartInfo.totalPrice >= giftProduct_2_price[0] && !cartInfo.productLists.includes(giftProductVariant_2_id[0])) {
                    console.log('simple gift after '+giftProduct_2_price[0]+' tor on')                 
                    document.querySelector(`#gift-product-${giftProductVariant_2_id[0]} button[name="add"]`).click();
                  }
                  //remove
                  if(cartInfo.totalPrice < giftProduct_2_price[0] && cartInfo.productLists.includes(giftProductVariant_2_id[0])) {
                    document.querySelector(`.cart-item[data-id="${giftProductVariant_2_id[0]}"] cart-remove-button`).click();
                  }

                  //10-8-2024 BFCM Added Code
                  //add universal gift (voucher)
                  //add product/gift (voucher)
                  if(cartInfo.totalPrice >= free_gift_voucher_price_1[0] && !cartInfo.productLists.includes(free_gift_voucher_variant_id_1[0])) {
                    console.log('simple gift after '+free_gift_voucher_price_1[0]+' tor on')
                    console.log(document.querySelector(`#gift-product-${free_gift_voucher_variant_id_1[0]} button[name="add"]`))
                    document.querySelector(`#gift-product-${free_gift_voucher_variant_id_1[0]} button[name="add"]`).click();
                  }
                  //remove
                  if(cartInfo.totalPrice < free_gift_voucher_price_1[0] && cartInfo.productLists.includes(free_gift_voucher_variant_id_1[0])) {
                    document.querySelector(`.cart-item[data-id="${free_gift_voucher_variant_id_1[0]}"] cart-remove-button`).click();
                  }             
              });

              //change button name in pdp Discovery Kit
              if (isThisProductPage()) {
                document.querySelector(`#showPU[data-id="2043719581766"]`).classList.add('discovery-hasin-cart');
                document.querySelector(`#showPU[data-id="2043719581766"]`).disabled = true;
              } 
            
              //Load VIP toggle
              loadVIPtoggle();

              //Load Barrage
              openpopupInsideDrawerbarrage();

        } else if (hasProduct2) {  
            
           //Setting Deluxe kit Cookie if in cart for itelligems test
           kitCookie("deluxeCart", "true", 14);
    
           checkCartTotal().then(cartInfo => {
                //add product gift
                if(cartInfo.totalPrice >= giftProduct_3_price[0] && !cartInfo.productLists.includes(giftProductVariant_3_id[0])) {
                  console.log('simple gift after '+giftProduct_3_price[0]+' tor on')                 
                  document.querySelector(`#gift-product-${giftProductVariant_3_id[0]} button[name="add"]`).click();
                }
                //remove
                if(cartInfo.totalPrice < giftProduct_3_price[0] && cartInfo.productLists.includes(giftProductVariant_3_id[0])) {
                  document.querySelector(`.cart-item[data-id="${giftProductVariant_3_id[0]}"] cart-remove-button`).click();
                }
  
                //add product gift
                if(cartInfo.totalPrice >= giftProduct_4_price[0] && !cartInfo.productLists.includes(giftProductVariant_4_id[0])) {
                  console.log('simple gift after '+giftProduct_4_price[0]+' tor on')                
                  document.querySelector(`#gift-product-${giftProductVariant_4_id[0]} button[name="add"]`).click();
                }
                //remove
                if(cartInfo.totalPrice < giftProduct_4_price[0] && cartInfo.productLists.includes(giftProductVariant_4_id[0])) {
                  document.querySelector(`.cart-item[data-id="${giftProductVariant_4_id[0]}"] cart-remove-button`).click();
                }
  
                //10-8-2024 BFCM Added Code
                //add universal gift (voucher)
                //add product/gift (voucher)
                if(cartInfo.totalPrice >= free_gift_voucher_price_1[0] && !cartInfo.productLists.includes(free_gift_voucher_variant_id_1[0])) {
                  console.log('simple gift after '+free_gift_voucher_price_1[0]+' tor on')
                  console.log(document.querySelector(`#gift-product-${free_gift_voucher_variant_id_1[0]} button[name="add"]`))
                  document.querySelector(`#gift-product-${free_gift_voucher_variant_id_1[0]} button[name="add"]`).click();
                }
                //remove
                if(cartInfo.totalPrice < free_gift_voucher_price_1[0] && cartInfo.productLists.includes(free_gift_voucher_variant_id_1[0])) {
                  document.querySelector(`.cart-item[data-id="${free_gift_voucher_variant_id_1[0]}"] cart-remove-button`).click();
                }
             
              });

              //change button name in pdp Discovery Kit
               if (isThisProductPage()) {
                document.querySelector(`#showPU[data-id="2043719581766"]`).classList.add('discovery-hasin-cart');
                document.querySelector(`#showPU[data-id="2043719581766"]`).disabled = true;
              }
            
            
              //Load VIP toggle
              loadVIPtoggle()

        } else if (hasMlab) {      
    
           checkCartTotal().then(cartInfo => {
                //add product gift
                if(cartInfo.totalPrice >= giftProduct_5_price[0] && !cartInfo.productLists.includes(giftProductVariant_5_id[0])) {
                  console.log('simple gift after '+giftProduct_5_price[0]+' tor on')               
                  document.querySelector(`#gift-product-${giftProductVariant_5_id[0]} button[name="add"]`).click();
                }
                //remove
                if(cartInfo.totalPrice < giftProduct_5_price[0] && cartInfo.productLists.includes(giftProductVariant_5_id[0])) {
                  document.querySelector(`.cart-item[data-id="${giftProductVariant_5_id[0]}"] cart-remove-button`).click();
                }
  
                //add product gift
                if(cartInfo.totalPrice >= giftProduct_6_price[0] && !cartInfo.productLists.includes(giftProductVariant_6_id[0])) {
                  console.log('simple gift after '+giftProduct_6_price[0]+' tor on')                 
                  document.querySelector(`#gift-product-${giftProductVariant_6_id[0]} button[name="add"]`).click();
                }
                //remove
                if(cartInfo.totalPrice < giftProduct_6_price[0] && cartInfo.productLists.includes(giftProductVariant_6_id[0])) {
                  document.querySelector(`.cart-item[data-id="${giftProductVariant_6_id[0]}"] cart-remove-button`).click();
                }

               const landingButtonMlab = document.getElementById('vip_mlab_atc');
               if (landingButtonMlab) {
                document.querySelector(`.vip_deluxe_atc-1`).classList.add('discovery-hasin-cart');
                document.querySelector(`.vip_deluxe_atc-1`).disabled = true; 
                document.querySelector(`.vip_deluxe_atc-1`).innerHTML = "Unavailable - Limit 1 Per Customer"; 
                document.querySelector(`.vip_deluxe_atc-2`).classList.add('discovery-hasin-cart');
                document.querySelector(`.vip_deluxe_atc-2`).disabled = true; 
                document.querySelector(`.vip_deluxe_atc-2`).innerHTML = "Unavailable - Limit 1 Per Customer";  
               };
               
              });
            
              //Load VIP toggle
              loadVIPtoggle()

        } else {
              
         checkCartTotal().then(cartInfo => {

            //remove special gift products if discovery product removed from cart
              if(cartInfo.productLists.includes(giftProductVariant_1_id[0]) && giftProductVariant_1_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_1_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_1_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_2_id[0]) && giftProductVariant_2_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_2_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_2_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_3_id[0]) && giftProductVariant_3_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_3_id[0]}"] cart-remove-button`).click();
                console.log('remove 3 gift'+giftProductVariant_3_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_4_id[0]) && giftProductVariant_4_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_4_id[0]}"] cart-remove-button`).click();
                console.log('remove 4 gift'+giftProductVariant_4_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_5_id[0]) && giftProductVariant_5_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_5_id[0]}"] cart-remove-button`).click();
                console.log('remove 5 gift'+giftProductVariant_5_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_6_id[0]) && giftProductVariant_6_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_6_id[0]}"] cart-remove-button`).click();
                console.log('remove 6 gift'+giftProductVariant_6_id[0])
              }

              //Barrage
              if(cartInfo.productLists.includes(giftProductVariant_6_id[0]) && giftProductVariant_6_id[0] != free_gift_without_discki_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_6_id[0]}"] cart-remove-button`).click();
                console.log('remove otoffer1 '+giftProductVariant_6_id[0])
              }

              //add simple gift products without discovery product in cart
              //add product gift
              if(cartInfo.totalPrice >= free_gift_without_discki_price_1[0] && !cartInfo.productLists.includes(free_gift_without_discki_variant_id_1[0])) {
                console.log('simple gift after '+free_gift_without_discki_price_1[0]+' tor on')
                console.log(document.querySelector(`#gift-product-${free_gift_without_discki_variant_id_1[0]} button[name="add"]`))
                document.querySelector(`#gift-product-${free_gift_without_discki_variant_id_1[0]} button[name="add"]`).click();
              }
              //remove
              if(cartInfo.totalPrice < free_gift_without_discki_price_1[0] && cartInfo.productLists.includes(free_gift_without_discki_variant_id_1[0])) {
                document.querySelector(`.cart-item[data-id="${free_gift_without_discki_variant_id_1[0]}"] cart-remove-button`).click();
              }

              //10-8-2024 BFCM Added Code
              //add universal gift (voucher)
              //add product/gift (voucher)
              if(cartInfo.totalPrice >= free_gift_voucher_price_1[0] && !cartInfo.productLists.includes(free_gift_voucher_variant_id_1[0])) {
                console.log('simple gift after '+free_gift_voucher_price_1[0]+' tor on')
                console.log(document.querySelector(`#gift-product-${free_gift_voucher_variant_id_1[0]} button[name="add"]`))
                document.querySelector(`#gift-product-${free_gift_voucher_variant_id_1[0]} button[name="add"]`).click();
              }
              //remove
              if(cartInfo.totalPrice < free_gift_voucher_price_1[0] && cartInfo.productLists.includes(free_gift_voucher_variant_id_1[0])) {
                document.querySelector(`.cart-item[data-id="${free_gift_voucher_variant_id_1[0]}"] cart-remove-button`).click();
              }


             //disabled ATC if in VIP Discovery Kit/mlab in cart
             const landingButton = document.getElementById('vip_deluxe_atc');
             if (landingButton) {
                if (hasProduct2) { 
                  document.querySelector(`.vip_deluxe_atc`).classList.add('discovery-hasin-cart');
                  document.querySelector(`.vip_deluxe_atc`).disabled = true; 
                  document.querySelector(`.vip_deluxe_atc`).innerHTML = "Unavailable - Limit 1 Per Customer"; 
                } else {
                  document.querySelector(`.vip_deluxe_atc`).classList.remove('discovery-hasin-cart');
                  document.querySelector(`.vip_deluxe_atc`).disabled = false;
                  document.querySelector(`.vip_deluxe_atc`).innerHTML = "ADD TO CART"; 
                }  
              }
              const landingButtonMlab = document.getElementById('vip_mlab_atc');
               if (landingButtonMlab) {
                document.querySelector(`.vip_deluxe_atc-1`).classList.remove('discovery-hasin-cart');
                document.querySelector(`.vip_deluxe_atc-1`).disabled = false;
                document.querySelector(`.vip_deluxe_atc-1`).innerHTML = "ADD TO CART"; 
                document.querySelector(`.vip_deluxe_atc-2`).classList.remove('discovery-hasin-cart');
                document.querySelector(`.vip_deluxe_atc-2`).disabled = false;
                document.querySelector(`.vip_deluxe_atc-2`).innerHTML = "ADD TO CART"; 
               }    
           
          }); 

            //Load VIP toggle
            loadVIPtoggle()

            //Load VIP toggle Price
            //loadCustomertoggleprice()         
          
            //remove VIP one month free if no kit in cart
            if (hasProduct1 || hasProduct2 == false) {
              if (hasProduct8 == true) {
                document.querySelector(`.cart-item[data-id="51814900728171"] cart-remove-button`).click();      
              }
            }

            //PDP2 button
            if (hasPdp == true) {
              console.log('pdp offer in cart');
              document.querySelector(`button#-submit.pdp_atc`).classList.add('discovery-hasin-cart');
              document.querySelector(`button#-submit.pdp_atc`).disabled = true;  
              document.querySelector(`button#-submit.pdp_atc`).innerHTML = "Unavailable - Limit 1 Per Customer"; 
            } else {
              console.log('pdp offer not in cart');
              if (isThisProductPage()) {
                document.querySelector(`button#-submit.pdp_atc`).classList.remove('discovery-hasin-cart');
                document.querySelector(`button#-submit.pdp_atc`).disabled = false;  
                document.querySelector(`button#-submit.pdp_atc`).innerHTML = "ADD TO CART"; 
              }
            }              

            //Redirect Page To Checkout if product in Cart
            if (hasProduct3 || hasProduct5 || hasProduct6 || hasProduct7) { 
              window.location.href = "https://eightsaintsskincare.com/checkout";
            }

            //change button name in pdp Discovery Kit
            if (hasProduct3 || hasProduct5 || hasProduct6 || hasProduct7) { 
              document.querySelector(`#showPU[data-id="2043719581766"]`).classList.add('discovery-hasin-cart');
              document.querySelector(`#showPU[data-id="2043719581766"]`).disabled = true;             
            } else {
               if (isThisProductPage()) {
                  document.querySelector(`#showPU[data-id="2043719581766"]`).classList.remove('discovery-hasin-cart');
                  document.querySelector(`#showPU[data-id="2043719581766"]`).disabled = false;
               }
            }         

        }
      })
      .catch(error => {
        
      });
  } 



  //discount trigger
  function trigetDiscountFiled(){
    const sourceField = document.getElementById('drawer-dosciun-field');
    const targetField = document.getElementById('drawer-dosciun-form');
  
  // Ensure both fields exist
  if (sourceField ) {
    sourceField.addEventListener('input', function() {
      // Update the value of the target field with the value from the source field
      targetField.value = sourceField.value;
    });
  }
  }trigetDiscountFiled()

//checking if this product page true or false
function isThisProductPage() {
  const analyticsScript = document.getElementById('shop-js-analytics');

  if (analyticsScript) {
    const analyticsData = JSON.parse(analyticsScript.textContent);

    if (analyticsData.pageType === 'product') {
      return true;
    }
  }

  return false;
}

//**Make sure cart products are rechecked on page load**/
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    // Code to run when page is restored from bfcache
    console.log('Page restored from bfcache');
    checkCartProducts()
    // Re-execute your JavaScript code here
  } else {
   // Code to run on initial page load
    console.log('Page loaded normally');
    checkCartProducts();
  }
});